export default __webpack_public_path__ + "static/experiment-goal-warning-light-mode-a5a9e8a64a2b3b1544190a99433ea9d0.png";